import { useQuery, type QueryClient } from '@tanstack/react-query';
import {
  getApiV2CustomersCustomerIdAccountSettings,
  StatusCode,
} from '@hungryroot/rest';

const TIME_LIMIT_15_MINUTES = 15 * 60 * 1000;

export function invalidateAccountSettings(queryClient: QueryClient) {
  queryClient.invalidateQueries({
    queryKey: ['account-settings'],
  });
}

export function useGetAccountSettings() {
  return useQuery({
    queryKey: ['account-settings'],
    queryFn: async () => {
      const res = await getApiV2CustomersCustomerIdAccountSettings();

      if (res.status === StatusCode.ClientErrorForbidden) {
        throw new Error('Unauthenticated');
      }

      if (res.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }
      return res.data;
    },
    gcTime: TIME_LIMIT_15_MINUTES,
    refetchInterval: TIME_LIMIT_15_MINUTES,
    staleTime: TIME_LIMIT_15_MINUTES,
  });
}
